'use client'
import AppLayout from '@/components/app/applayout'
import ErrorPage from '@/components/error/page'
import React from 'react'

export default function NotFound() {
  return (
    <AppLayout>
      <ErrorPage/>
    </AppLayout>
  )
}
